// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as WeeklyEarningsDetailsVMMapper from "../../vm-mapper/driver-earnings-list/WeeklyEarningsDetailsVMMapper.bs.js";
import * as WeeklyEarningsDetailsViewMapper from "../../vm-mapper/driver-earnings-list/WeeklyEarningsDetailsViewMapper.bs.js";

function WeeklyEarningsDetailsList$WeeklyEarningsDetails(Props) {
  var data = Props.data;
  var viewModel = WeeklyEarningsDetailsVMMapper.WeeklyEarningsDetailsVMMapper.getViewModel(data);
  return React.createElement("div", undefined, WeeklyEarningsDetailsViewMapper.WeeklyEarningsDetailsViewMapper.getView(viewModel));
}

var WeeklyEarningsDetails = {
  make: WeeklyEarningsDetailsList$WeeklyEarningsDetails
};

var LoaderConfig = {};

var EarningsListLoaderComponent = LoaderComponent$Catalyst.LoaderComponent(LoaderConfig);

function WeeklyEarningsDetailsList$WeeklyEarningsDetailsWrapper(Props) {
  var msisdn = Props.msisdn;
  var startDate = Props.startDate;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(EarningsListLoaderComponent.make, {
              fetchData: (function (param) {
                  var RepoInstance = CrmRepoManager.getDriverEarningsRepo(undefined);
                  return Curry._3(RepoInstance.fetchDriverDailyEarningDetails, msisdn, startDate, country);
                }),
              renderView: (function (earnings, _refreshView) {
                  return React.createElement(WeeklyEarningsDetailsList$WeeklyEarningsDetails, {
                              data: earnings
                            });
                })
            });
}

var WeeklyEarningsDetailsWrapper = {
  LoaderConfig: LoaderConfig,
  EarningsListLoaderComponent: EarningsListLoaderComponent,
  make: WeeklyEarningsDetailsList$WeeklyEarningsDetailsWrapper
};

export {
  WeeklyEarningsDetails ,
  WeeklyEarningsDetailsWrapper ,
  
}
/* EarningsListLoaderComponent Not a pure module */
